module.exports = __webpack_public_path__ + "static/media/hands.e106e388.svg";